<template>
  <div class="wrap animate__animated animate__fadeIn">
    <div class="title">
      <span>直播画面</span>
      <div class="btn" @click="editMonitor"><span>编辑</span></div>
    </div>
    <div class="cont_box">
      <div class="box_left" :class="isLeftOpen ? 'open' : 'close'">
        <div class="close_btn" v-if="isLeftOpen" @click="isLeftOpen = false"><img src="../../../assets/img/left.png" /></div>
        <div class="open_btn" v-else @click="isLeftOpen = true"><img src="../../../assets/img/right.png" /></div>
        <div class="left_top">
          <div class="list_title">视图控制</div>
          <div class="list_item">
            <div class="list_check" @click="fnShowLive(1)">
              <div class="one" :class="selectControl == 1 ? 'active' : ''"></div>
              <div class="title">1宫格</div>
            </div>
            <div class="list_check" @click="fnShowLive(4)">
              <div class="four" :class="selectControl == 4 ? 'active' : ''"></div>
              <div class="title">4宫格</div>
            </div>
            <div class="list_check" @click="fnShowLive(9)">
              <div class="nine" :class="selectControl == 9 ? 'active' : ''"></div>
              <div class="title">9宫格</div>
            </div>
          </div>
        </div>
        <div class="left_bottom">
          <div class="left_title">监控列表</div>
          <div class="list_box">
            <div class="list_all" v-if="leftList.length > 0">
              <div class="list_item" :class="item.selected ? 'active' : ''" v-for="(item, index) in leftList" :key="index" @click="fnChooseChannel(item, index)">
                <i class="el-icon-check yes" v-if="item.selected"></i>
                <div class="item_title">{{ index + 1 }}.{{ item.name ? item.name : '未命名' }}</div>
                <div class="item_img">
                  <img :src="item.cover" v-if="item.cover" />
                  <img src="../../../assets/img/nos.png" v-else />
                </div>
              </div>
            </div>
            <div class="list_all center" v-else>暂无数据</div>
          </div>
        </div>
      </div>
      <!-- 1宫格 -->
      <div class="monitor_live one" v-if="selectControl == 1">
        <div class="control">
          <div class="btn" :class="oneList.quality == 1 ? 'active' : ''" @click="fnChangeOneQuality('1')">标清</div>
          <div class="btn" :class="oneList.quality == 2 ? 'active' : ''" @click="fnChangeOneQuality('2')">高清</div>
        </div>
        <!-- <div class="control_set" @click="fnSetOneControl">
                  <span class="el-icon-setting"></span>
              </div>
              <div class="control_list" v-if="oneList.showSet">
                <div class="list_left">
                    <div class="left_top">
                        <div class="control_btn" :class="oneList.speed==0?'yellow':'blue'" @click="fnSelectOneSpeed(0)"><span>慢</span></div>
                    </div>
                    <div class="left_center">
                        <div class="control_btn" :class="oneList.speed==1?'yellow':'blue'" @click="fnSelectOneSpeed(1)"><span>适中</span></div>
                    </div>
                    <div class="left_bottom">
                        <div class="control_btn" :class="oneList.speed==2?'yellow':'blue'" @click="fnSelectOneSpeed(2)"><span>快</span></div>
                    </div>
                </div>
                <div class="list_center">
                    <div class="center_top">
                        <div class="control_btn blue f-20" @click="fnControl({deviceSerial: oneList.deviceSerial, channelNo: oneList.channelNo, direction: 8, speed: oneList.speed })"><span><svg-icon icon-class="icon-enlarge" /></span></div>
                        <div class="control_btn blue" @click="fnControl({deviceSerial: oneList.deviceSerial, channelNo: oneList.channelNo, direction: 10, speed: oneList.speed })"><span><svg-icon icon-class="icon-focus-close" /></span></div>
                    </div>
                    <div class="center_center">
                        <div class="control_btn blue f-20" @click="fnControl({ deviceSerial: oneList.deviceSerial, channelNo: oneList.channelNo, direction: 9, speed: oneList.speed })"><span><svg-icon icon-class="icon-narrow" /></span></div>
                        <div class="control_btn blue" @click="fnControl({ deviceSerial: oneList.deviceSerial, channelNo: oneList.channelNo, direction: 11, speed: oneList.speed })"><span><svg-icon icon-class="icon-focus-far" /></span></div>
                    </div>
                    <div class="center_bottom">
                        <div class="control_btn">(空)</div>
                    </div>
                </div>
                <div class="list_right">
                    <div class="right_top">
                        <div class="control_btn blue" @click="fnControl({deviceSerial: oneList.deviceSerial, channelNo: oneList.channelNo, direction: 4, speed: oneList.speed })"><span>左上</span></div>
                        <div class="control_btn blue" @click="fnControl({deviceSerial: oneList.deviceSerial, channelNo: oneList.channelNo, direction: 0, speed: oneList.speed })"><span>上</span></div>
                        <div class="control_btn blue" @click="fnControl({deviceSerial: oneList.deviceSerial, channelNo: oneList.channelNo, direction: 6, speed: oneList.speed })"><span>右上</span></div>
                    </div>
                    <div class="right_center">
                        <div class="control_btn blue" @click="fnControl({deviceSerial: oneList.deviceSerial, channelNo: oneList.channelNo, direction: 2, speed: oneList.speed })"><span>左</span></div>
                        <div class="control_btn">(空)</div>
                        <div class="control_btn blue" @click="fnControl({deviceSerial: oneList.deviceSerial, channelNo: oneList.channelNo, direction: 3, speed: oneList.speed })"><span>右</span></div>
                    </div>
                    <div class="right_bottom">
                        <div class="control_btn blue" @click="fnControl({deviceSerial: oneList.deviceSerial, channelNo: oneList.channelNo, direction: 5, speed: oneList.speed })"><span>左下</span></div>
                        <div class="control_btn blue" @click="fnControl({deviceSerial: oneList.deviceSerial, channelNo: oneList.channelNo, direction: 1, speed: oneList.speed })"><span>下</span></div>
                        <div class="control_btn blue" @click="fnControl({deviceSerial: oneList.deviceSerial, channelNo: oneList.channelNo, direction: 7, speed: oneList.speed })"><span>右下</span></div>
                    </div>
                </div>
              </div> -->
        <video
          class="video"
          v-if="oneList.liveAddress || oneList.hdAddress"
          id="player_one"
          :src="oneList.quality == 1 ? oneList.liveAddress : oneList.hdAddress"
          controls
          playsInline
          webkit-playsinline
        ></video>
        <img class="img" v-else src="../../../assets/img/no.png" />
      </div>
      <!-- 4宫格 -->
      <div class="monitor_live four" v-else-if="selectControl == 4">
        <div class="list_one" :class="fourSelect == index ? 'active' : ''" v-for="(item, index) in fourList" :key="index" @click="fourSelect = index">
          <div class="control">
            <div class="btn" :class="item.quality == 1 ? 'active' : ''" @click="fnChangeFourQuality(index, '1')">标清</div>
            <div class="btn" :class="item.quality == 2 ? 'active' : ''" @click="fnChangeFourQuality(index, '2')">高清</div>
          </div>
          <!-- <div class="control_set" @click="fnSetFourControl(index)">
                    <span class="el-icon-setting"></span>
                </div>
                <div class="control_list" v-if="item.showSet">
                  <div class="list_left">
                      <div class="left_top">
                          <div class="control_btn" :class="item.speed==0?'yellow':'blue'" @click="fnSelectFourSpeed(0,index)"><span>慢</span></div>
                      </div>
                      <div class="left_center">
                          <div class="control_btn" :class="item.speed==1?'yellow':'blue'" @click="fnSelectFourSpeed(1,index)"><span>适中</span></div>
                      </div>
                      <div class="left_bottom">
                          <div class="control_btn" :class="item.speed==2?'yellow':'blue'" @click="fnSelectFourSpeed(2,index)"><span>快</span></div>
                      </div>
                  </div>
                  <div class="list_center">
                      <div class="center_top">
                          <div class="control_btn blue f-20" @click="fnControl({deviceSerial: item.deviceSerial, channelNo: item.channelNo, direction: 8, speed: item.speed })"><span><svg-icon icon-class="icon-enlarge" /></span></div>
                          <div class="control_btn blue" @click="fnControl({deviceSerial: item.deviceSerial, channelNo: item.channelNo, direction: 10, speed: item.speed })"><span><svg-icon icon-class="icon-focus-close" /></span></div>
                      </div>
                      <div class="center_center">
                          <div class="control_btn blue f-20" @click="fnControl({ deviceSerial: item.deviceSerial, channelNo: item.channelNo, direction: 9, speed: item.speed })"><span><svg-icon icon-class="icon-narrow" /></span></div>
                          <div class="control_btn blue" @click="fnControl({ deviceSerial: item.deviceSerial, channelNo: item.channelNo, direction: 11, speed: item.speed })"><span><svg-icon icon-class="icon-focus-far" /></span></div>
                      </div>
                      <div class="center_bottom">
                          <div class="control_btn">(空)</div>
                      </div>
                  </div>
                  <div class="list_right">
                      <div class="right_top">
                          <div class="control_btn blue" @click="fnControl({deviceSerial: item.deviceSerial, channelNo: item.channelNo, direction: 4, speed: item.speed })"><span>左上</span></div>
                          <div class="control_btn blue" @click="fnControl({deviceSerial: item.deviceSerial, channelNo: item.channelNo, direction: 0, speed: item.speed })"><span>上</span></div>
                          <div class="control_btn blue" @click="fnControl({deviceSerial: item.deviceSerial, channelNo: item.channelNo, direction: 6, speed: item.speed })"><span>右上</span></div>
                      </div>
                      <div class="right_center">
                          <div class="control_btn blue" @click="fnControl({deviceSerial: item.deviceSerial, channelNo: item.channelNo, direction: 2, speed: item.speed })"><span>左</span></div>
                          <div class="control_btn">(空)</div>
                          <div class="control_btn blue" @click="fnControl({deviceSerial: item.deviceSerial, channelNo: item.channelNo, direction: 3, speed: item.speed })"><span>右</span></div>
                      </div>
                      <div class="right_bottom">
                          <div class="control_btn blue" @click="fnControl({deviceSerial: item.deviceSerial, channelNo: item.channelNo, direction: 5, speed: item.speed })"><span>左下</span></div>
                          <div class="control_btn blue" @click="fnControl({deviceSerial: item.deviceSerial, channelNo: item.channelNo, direction: 1, speed: item.speed })"><span>下</span></div>
                          <div class="control_btn blue" @click="fnControl({deviceSerial: item.deviceSerial, channelNo: item.channelNo, direction: 7, speed: item.speed })"><span>右下</span></div>
                      </div>
                  </div>
                </div> -->
          <video
            class="video"
            v-if="item.liveAddress || item.hdAddress"
            :id="'player_four' + index"
            :src="item.quality == 1 ? item.liveAddress : item.hdAddress"
            controls
            playsInline
            webkit-playsinline
          ></video>
          <img class="img" v-else src="../../../assets/img/no.png" />
        </div>
      </div>
      <!-- 9宫格 -->
      <div class="monitor_live nine" v-else-if="selectControl == 9">
        <div class="list_box" :class="nineSelect == index ? 'active' : ''" v-for="(item, index) in nineList" :key="index" @click="nineSelect = index">
          <div class="control">
            <div class="btn" :class="item.quality == 1 ? 'active' : ''" @click="fnChangeNineQuality(index, '1')">标清</div>
            <div class="btn" :class="item.quality == 2 ? 'active' : ''" @click="fnChangeNineQuality(index, '2')">高清</div>
          </div>
          <!-- <div class="control_set" @click="fnSetNineControl(index)">
                    <span class="el-icon-setting"></span>
                </div>
                <div class="control_list" v-if="item.showSet">
                  <div class="list_left">
                      <div class="left_top">
                          <div class="control_btn" :class="item.speed==0?'yellow':'blue'" @click="fnSelectNineSpeed(0,index)"><span>慢</span></div>
                      </div>
                      <div class="left_center">
                          <div class="control_btn" :class="item.speed==1?'yellow':'blue'" @click="fnSelectNineSpeed(1,index)"><span>适中</span></div>
                      </div>
                      <div class="left_bottom">
                          <div class="control_btn" :class="item.speed==2?'yellow':'blue'" @click="fnSelectNineSpeed(2,index)"><span>快</span></div>
                      </div>
                  </div>
                  <div class="list_center">
                      <div class="center_top">
                          <div class="control_btn blue f-20" @click="fnControl({deviceSerial: item.deviceSerial, channelNo: item.channelNo, direction: 8, speed: item.speed })"><span><svg-icon icon-class="icon-enlarge" /></span></div>
                          <div class="control_btn blue" @click="fnControl({deviceSerial: item.deviceSerial, channelNo: item.channelNo, direction: 10, speed: item.speed })"><span><svg-icon icon-class="icon-focus-close" /></span></div>
                      </div>
                      <div class="center_center">
                          <div class="control_btn blue f-20" @click="fnControl({ deviceSerial: item.deviceSerial, channelNo: item.channelNo, direction: 9, speed: item.speed })"><span><svg-icon icon-class="icon-narrow" /></span></div>
                          <div class="control_btn blue" @click="fnControl({ deviceSerial: item.deviceSerial, channelNo: item.channelNo, direction: 11, speed: item.speed })"><span><svg-icon icon-class="icon-focus-far" /></span></div>
                      </div>
                      <div class="center_bottom">
                          <div class="control_btn">(空)</div>
                      </div>
                  </div>
                  <div class="list_right">
                      <div class="right_top">
                          <div class="control_btn blue" @click="fnControl({deviceSerial: item.deviceSerial, channelNo: item.channelNo, direction: 4, speed: item.speed })"><span>左上</span></div>
                          <div class="control_btn blue" @click="fnControl({deviceSerial: item.deviceSerial, channelNo: item.channelNo, direction: 0, speed: item.speed })"><span>上</span></div>
                          <div class="control_btn blue" @click="fnControl({deviceSerial: item.deviceSerial, channelNo: item.channelNo, direction: 6, speed: item.speed })"><span>右上</span></div>
                      </div>
                      <div class="right_center">
                          <div class="control_btn blue" @click="fnControl({deviceSerial: item.deviceSerial, channelNo: item.channelNo, direction: 2, speed: item.speed })"><span>左</span></div>
                          <div class="control_btn">(空)</div>
                          <div class="control_btn blue" @click="fnControl({deviceSerial: item.deviceSerial, channelNo: item.channelNo, direction: 3, speed: item.speed })"><span>右</span></div>
                      </div>
                      <div class="right_bottom">
                          <div class="control_btn blue" @click="fnControl({deviceSerial: item.deviceSerial, channelNo: item.channelNo, direction: 5, speed: item.speed })"><span>左下</span></div>
                          <div class="control_btn blue" @click="fnControl({deviceSerial: item.deviceSerial, channelNo: item.channelNo, direction: 1, speed: item.speed })"><span>下</span></div>
                          <div class="control_btn blue" @click="fnControl({deviceSerial: item.deviceSerial, channelNo: item.channelNo, direction: 7, speed: item.speed })"><span>右下</span></div>
                      </div>
                  </div>
                </div> -->
          <video
            class="video"
            v-if="item.liveAddress || item.hdAddress"
            :id="'player_nine' + index"
            :src="item.quality == 1 ? item.liveAddress : item.hdAddress"
            controls
            playsInline
            webkit-playsinline
          ></video>
          <img class="img" v-else src="../../../assets/img/no.png" />
        </div>
      </div>
    </div>
    <div class="dialog_device animate__animated animate__fadeIn" v-if="editMonitorIsShow">
      <el-dialog :modal="false" title="编辑设备" :visible.sync="editMonitorIsShow" center style="text-align: center;">
        <div class="cont_list">
          <div class="list_title">
            <div class="title_item">
              封面&nbsp;
              <button class="add_btn yellow" @click="fnGetAllCover()">获取全部封面</button>
            </div>
            <div class="title_item">通道号</div>
            <div class="title_item">通道名称</div>
            <div class="title_item">操作</div>
          </div>
          <div class="list_boxes">
            <div class="list_box">
              <div v-if="channelData">
                <div class="box_line" v-for="(item, index) in channelData" :key="index">
                  <div class="list_item">
                    <div>
                      <div @click="fnGetIndex(index)" class="cover_img">
                        <el-upload class="avatar-uploader" action="" :before-upload="fnUploadCover" :on-success="handleCoverSuccess" :show-file-list="false">
                          <img v-if="item.cover" :src="item.cover" class="avatar" />
                          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                      </div>
                      <div class="cover_btn">
                        <button class="add_btn yellow" @click="fnGetChannelCover(item, index)">获取封面</button>
                        <button class="add_btn blue" @click="fnSeeCover(item.cover)">查看封面</button>
                      </div>
                    </div>
                  </div>
                  <div class="list_item" :title="item.channelNo">
                    <span>{{ item.channelNo }}</span>
                  </div>
                  <div class="list_item">
                    <div class="line_input2"><input style="padding:5px;" class="input_box" placeholder="请输入通道名称" v-model="channelData[index].name" /></div>
                  </div>
                  <div class="list_item" :title="item.content">
                    <el-checkbox v-model="channelData[index].is_home" :checked="channelData[index].is_home == 1" @change="handleCheckedisHomeChange(index)">
                      设为投屏地址
                    </el-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div slot="footer" class="dialog-footer" style="">
          <div class="btn_line">
            <div class="search-btn red" @click="editMonitorIsShow = false"><span>取消</span></div>
            <div class="search-btn" @click="fnEditMonitor"><span>保存</span></div>
          </div>
        </div>
      </el-dialog>
    </div>
    <!-- 查看封面 -->
    <div class="dialog_pic animate__animated animate__fadeIn" v-if="seeCoverIsShow">
      <el-dialog :modal="false" title="查看封面" :visible.sync="seeCoverIsShow" center style="text-align: center;"><img :src="seeCoverSrc" class="cover_pic" /></el-dialog>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request';
import fnRequest from '@/utils/monitor';
import EZUIKit from '../../../../static/ezuikit';

export default {
  data() {
    return {
      isLeftOpen: true,
      selectControl: 9,
      monitorToken: '', // 视频监控token
      editObj: [],
      liveList: [],
      channelData: [],
      leftList: [],
      oneList: {}, // 1宫格直播列表
      fourList: [], // 4宫格直播列表
      nineList: [], // 9宫格直播列表
      fourSelect: null, // 选择的 4 宫格 通道
      nineSelect: null, // 选择的 9 宫格 通道
      player_one: null, // 萤石云初始化 1 宫格
      player_four: [], // 萤石云初始化 4 宫格
      player_nine: [], // 萤石云初始化 9 宫格
      editMonitorIsShow: false, // 编辑弹窗
      formLabelWidth: '120px',
      seeCoverIsShow: false, // 查看封面弹窗
      seeCoverSrc: '', // 封面src
      form: {},
      selectedData: [] // 设置为首页投屏地址的元素
    };
  },
  created() {
    this.fnGetMonitorToken();
    this.fnInit();
  },
  beforeDestroy() {},
  methods: {
    // 初始化
    fnInit() {
      this.fnGetData();
    },
    // 获取监控数据
    fnGetData() {
      request({
        url: 'zgj-monitor/getMonitorList',
        methods: 'GET'
      })
        .then(res => {
          if (res.code == 1) {
            let _data = res.data;
            let _arr = [];
            let _editObj = [];
            for (let i in _data) {
              let _deviceSerial = _data[i].deviceSerial;
              _editObj.push({ id: _data[i].id, deviceSerial: _deviceSerial });
              let _channel = _data[i].channel ? JSON.parse(_data[i].channel) : {};
              for (let j in _channel) {
                _channel[j].deviceSerial = _deviceSerial;
                _arr.push(_channel[j]);
              }
            }
            let _arrt = [];
            for (let i in _arr) {
              let _index1 = _arr[i].liveAddress.lastIndexOf(':');
              _arr[i].liveAddress = 'https' + _arr[i].liveAddress.slice(_index1);
              let _index2 = _arr[i].hdAddress.lastIndexOf(':');
              _arr[i].hdAddress = 'https' + _arr[i].hdAddress.slice(_index2);
              _arr[i].quality = '1';
              _arr[i].speed = 1;
              _arr[i].selected = false;
              _arr[i].showSet = false;
              if (_arr[i].is_home == 1) {
                _arrt.push(_arr[i]);
              }
            }
            this.selectedData = _arrt;
            this.editObj = _editObj;
            this.liveList = _arr;
            this.channelData = _arr;
            this.fnShowLive(1);
          }
        })
        .catch(err => {
          this.$message.error(err.data);
        });
    },
    // 获取监控地址token
    fnGetMonitorToken() {
      fnRequest({
        url: 'get_token',
        method: 'GET'
      })
        .then(res => {
          this.monitorToken = res.data;
        })
        .catch(err => {
          this.$message.error(err.data);
        });
    },
    // 根据选择的宫格 初始化直播
    fnShowLive(control) {
      this.fnStopLive();
      this.selectControl = control;
      let _list = JSON.parse(JSON.stringify(this.liveList));
      this.leftList = _list;
      let arr = [];
      for (let i in _list) {
        if (i < control) {
          _list[i].selected = true;
          arr.push(_list[i]);
        } else {
          _list[i].selected = false;
        }
      }
      if (arr.length < control) {
        let _len = control - arr.length;
        for (let i = 0; i < _len; i++) {
          arr.push({ cover: '../assets/no.png' });
        }
      }
      if (control == 1) {
        this.oneList = arr[0];
        this.$nextTick(() => {
          this.player_one = new EZUIKit.EZUIPlayer('player_one');
          this.player_one.play();
        });
      } else if (control == 4) {
        this.fourList = arr;
        this.$nextTick(() => {
          for (let i in this.fourList) {
            if (this.fourList[i].liveAddress) {
              let _id = 'player_four' + i;
              this.player_four[_id] = new EZUIKit.EZUIPlayer(_id);
              this.player_four[_id].play();
            }
          }
        });
      } else if (control == 9) {
        this.nineList = arr;
        this.$nextTick(() => {
          for (let i in this.nineList) {
            if (this.nineList[i].liveAddress) {
              let _id = 'player_nine' + i;
              this.player_nine[_id] = new EZUIKit.EZUIPlayer(_id);
              this.player_nine[_id].play();
            }
          }
        });
      }
    },
    // 暂停直播画面
    fnStopLive() {
      if (this.player_one) {
        this.player_one.stop();
        this.player_one = null;
      }
      if (this.player_four.length) {
        this.player_four.forEach((item, index) => {
          this.player_four[index].stop();
        });
        this.player_four = [];
      }
      if (this.player_nine.length) {
        this.player_nine.forEach((item, index) => {
          this.player_nine[index].stop();
        });
        this.player_nine = [];
      }
    },
    // 切换1宫格直播高清 标清
    fnChangeOneQuality(quality) {
      this.oneList.quality = quality;
      this.$nextTick(() => {
        this.player_one = new EZUIKit.EZUIPlayer('player_one');
        this.player_one.play();
      });
    },
    // 切换4宫格直播高清 标清
    fnChangeFourQuality(index, quality) {
      this.fourList[index].quality = quality;
      this.$nextTick(() => {
        this.player_four[index] = new EZUIKit.EZUIPlayer('player_four' + index);
        this.player_four[index].play();
      });
    },
    // 切换9宫格直播高清 标清
    fnChangeNineQuality(index, quality) {
      this.nineList[index].quality = quality;
      this.$nextTick(() => {
        this.player_nine[index] = new EZUIKit.EZUIPlayer('player_nine' + index);
        this.player_nine[index].play();
      });
    },
    // 判断页面是显示的全部直播还是单个回放
    fnPlayBack() {
      let _obj = {};
      if (this.selectControl == 1) {
        _obj = this.oneList;
      } else if (this.selectControl == 4) {
        if (this.fourSelect != null) {
          _obj = this.fourList[this.fourSelect];
        } else {
          return this.$message.warning('请点击选择通道后再查看回放！');
        }
      } else if (this.selectControl == 9) {
        if (this.nineSelect != null) {
          _obj = this.nineList[this.nineSelect];
        } else {
          return this.$message.warning('请点击选择通道后再查看回放！');
        }
      }
      if (_obj.liveAddress) {
        this.isChooseTime = true;
        this.chooseTime = '';
        this.selectChannel = _obj;
      } else {
        this.$message.warning('请选择正确的通道！');
      }
    },
    // 选择侧边栏通道
    fnChooseChannel(item, index) {
      if (this.selectControl == 0) {
        return this.$message.warning('请打开侧边栏‘试图控制’版块选择需要显示的宫格！');
      } else if (this.selectControl == 1) {
        if (item.channelNo == this.oneList.channelNo && item.deviceSerial == this.oneList.deviceSerial) {
          this.leftList[index].selected = false;
          this.oneList = { cover: '../../../assets/img/no.png' };
        } else {
          for (let i in this.leftList) {
            this.leftList[i].selected = false;
          }
          this.leftList[index].selected = true;
          this.oneList = item;
          this.fnStopLive();
          this.$nextTick(() => {
            this.player_one = new EZUIKit.EZUIPlayer('player_one');
            this.player_one.play();
          });
        }
      } else if (this.selectControl == 4) {
        let _leftList = JSON.parse(JSON.stringify(this.leftList));
        // 先取出所有选中的通道
        let _arr = [];
        for (let i in this.leftList) {
          if (this.leftList[i].selected) {
            _arr.push(this.leftList[i]);
          }
        }
        let _status = false;
        // 判断刚选择的是否在选中的通道
        for (let j in _arr) {
          if (_arr[j].channelNo == item.channelNo && _arr[j].deviceSerial == item.deviceSerial) {
            _arr.splice(j, 1);
            _leftList[index].selected = false;
            _status = true;
          }
        }
        if (!_status) {
          if (_arr.length >= 4) {
            return this.$message.warning('请取消其他通道后再进行切换！');
          } else {
            _leftList[index].selected = true;
          }
        }
        // 再次取出所有选中的
        let _arrSelect = [];
        for (let m in _leftList) {
          if (_leftList[m].selected) {
            _arrSelect.push(_leftList[m]);
          }
        }
        if (_arrSelect.length < 4) {
          let _len = 4 - _arrSelect.length;
          for (let k = 0; k < _len; k++) {
            _arrSelect.push({ cover: '../../../assets/img/no.png' });
          }
        }
        this.fnStopLive();
        this.leftList = _leftList;
        this.fourList = _arrSelect;
        this.$nextTick(() => {
          for (let n in this.fourList) {
            if (this.fourList[n].liveAddress) {
              let _id = 'player_four' + n;
              this.player_four[_id] = new EZUIKit.EZUIPlayer(_id);
              this.player_four[_id].play();
            }
          }
        });
      } else if (this.selectControl == 9) {
        let _leftList = JSON.parse(JSON.stringify(this.leftList));
        // 先取出所有选中的通道
        let _arr = [];
        for (let i in this.leftList) {
          if (this.leftList[i].selected) {
            _arr.push(this.leftList[i]);
          }
        }
        let _status = false;
        // 判断刚选择的是否在选中的通道
        for (let j in _arr) {
          if (_arr[j].channelNo == item.channelNo && _arr[j].deviceSerial == item.deviceSerial) {
            _arr.splice(j, 1);
            _leftList[index].selected = false;
            _status = true;
          }
        }
        if (!_status) {
          if (_arr.length >= 9) {
            return this.$message.warning('请取消其他通道后再进行切换！');
          } else {
            _leftList[index].selected = true;
          }
        }
        // 再次取出所有选中的
        let _arrSelect = [];
        for (let m in _leftList) {
          if (_leftList[m].selected) {
            _arrSelect.push(_leftList[m]);
          }
        }
        if (_arrSelect.length < 9) {
          let _len = 9 - _arrSelect.length;
          for (let k = 0; k < _len; k++) {
            _arrSelect.push({ cover: '../assets/no.png' });
          }
        }
        this.fnStopLive();
        this.leftList = _leftList;
        this.nineList = _arrSelect;
        this.$nextTick(() => {
          for (let n in this.nineList) {
            if (this.nineList[n].liveAddress) {
              let _id = 'player_nine' + n;
              this.player_nine[_id] = new EZUIKit.EZUIPlayer(_id);
              this.player_nine[_id].play();
            }
          }
        });
      }
    },
    // // 1宫格 控制试图切换
    // fnSetOneControl(){
    //    this.oneList.showSet = !this.oneList.showSet
    // },
    // // 4宫格 控制视图切换
    // fnSetFourControl(index){
    //     this.fourList[index].showSet = !this.fourList[index].showSet
    // },
    // // 9宫格 控制视图切换
    // fnSetNineControl(index){
    //     this.nineList[index].showSet = !this.nineList[index].showSet
    // },
    // // 1宫格 选择设备速度
    // fnSelectOneSpeed(_value) {
    //     this.oneList.speed = _value;
    // },
    // // 4宫格 选择设备速度
    // fnSelectFourSpeed(_value,index){
    //     this.fourList[index].speed = _value
    // },
    // // 9宫格 选择设备速度
    // fnSelectNineSpeed(_value,index){
    //     this.nineList[index].speed = _value
    // },
    // // 1宫格 控制设备
    //  fnControl(_data){
    //     this.fnStartControl(_data);
    //     setTimeout(() => {
    //     	this.fnStopControl(_data);
    //     }, 500);
    //  },
    //  // 开始控制
    //  fnStartControl(_data) {
    //  	let _obj = {
    //  		state: 'start',
    //  		deviceSerial: _data.deviceSerial,
    //  		channelNo: _data.channelNo,
    //  		direction: _data.direction,
    //  		speed: _data.speed,
    //  	};
    //  	this.fnControlMonitor(_obj);
    //  },
    //  // 结束控制
    //  fnStopControl(_data) {
    //  	let _obj = {
    //  		state: 'stop',
    //  		deviceSerial: _data.deviceSerial,
    //  		channelNo: _data.channelNo,
    //  		direction: _data.direction,
    //  		speed: _data.speed,
    //  	};
    //  	this.fnControlMonitor(_obj);
    //  },
    //  // 设备控制公共方法
    //  fnControlMonitor(_obj) {
    //  	fnRequest({
    //  		url: 'control_ysy',
    //  		method: 'POST',
    //  		data: _obj
    //  	})
    //  		.then(res => {
    //  		})
    //  		.catch(err => {
    //  		});
    //  },
    // 获取所有封面
    fnGetAllCover() {
      let _data = this.channelData;
      let _errorNum = 0; // 失败条数
      let _count = 0; // 请求条数
      let _text = []; // 获取失败的通道号
      let _loading = Loading.service({
        fullscreen: true,
        background: 'rgba(255,255,255,0)',
        spinner: 'el-icon-loading'
      });
      _data.forEach((item, index) => {
        request({
          url: 'zgj-monitor/get_cover_ysy',
          method: 'POST',
          notLoading: true,
          data: {
            deviceSerial: this.editDeviceSerial,
            channelNo: item.channelNo
          }
        })
          .then(res => {
            this.channelData[index].cover = res.data;
            _count++;
            if (_count == this.channelData.length) {
              if (_errorNum) {
                _loading.close();
                this.$message.error(_text.join('、') + '封面获取失败');
              } else {
                _loading.close();

                this.$message.success('获取成功');
              }
            }
          })
          .catch(err => {
            _errorNum++;
            _count++;
            let _str = '通道' + item.channelNo;
            _text.push(_str);
            if (_count == this.channelData.length) {
              _loading.close();
              this.$message.error(_text.join('、') + '封面获取失败');
            }
          });
      });
    },
    // 获取通道封面
    fnGetChannelCover(_obj, _index) {
      request({
        url: 'zgj-monitor/get_cover_ysy',
        method: 'POST',
        data: {
          deviceSerial: _obj.deviceSerial,
          channelNo: _obj.channelNo
        }
      })
        .then(res => {
          this.channelData[_index].cover = res.data;
        })
        .catch(err => {
          this.$message.error(err.data);
        });
    },
    // 查看封面
    fnSeeCover(_url) {
      this.seeCoverSrc = _url;
      this.seeCoverIsShow = true;
    },
    // 上传封面
    fnUploadCover(file) {
      let formData = new FormData();
      formData.append('file', file);
      formData.append('type', 'image');
      fnUpload(formData, res => {
        this.$set(this.channelData[this.imgIndex], 'cover', res.data.file_url);
        this.editMonitorIsShow = false;
        this.editMonitorIsShow = true;
      });
      return false;
    },
    // 上传图片的索引
    fnGetIndex(_index) {
      this.imgIndex = _index;
    },
    // 封面上传成功
    handleCoverSuccess(res, file) {},
    // 打开编辑弹窗
    editMonitor() {
      this.editMonitorIsShow = true;
    },
    // 切换设置投屏地址
    handleCheckedisHomeChange(_index) {
      if (this.selectedData.length > 1 && this.channelData[_index].is_home) {
        this.$message.warning('首页最多只支持同时播放两个监控视频');
        this.channelData[_index].is_home = !this.channelData[_index].is_home;
        return;
      }
      let _arr = [];
      for (let i = 0; i < this.channelData.length; i++) {
        if (this.channelData[i].is_home) {
          _arr.push(this.channelData[i]);
        }
      }
      this.selectedData = _arr;
    },
    // 保存编辑设备
    fnEditMonitor() {
      if (this.selectedData.length > 0) {
        for (let i in this.channelData) {
          if (this.channelData[i].is_home) {
            this.channelData[i].is_home = 1;
          } else {
            this.channelData[i].is_home = 0;
          }
        }
      }
      let _channelData = JSON.parse(JSON.stringify(this.channelData));
      for (let i in this.editObj) {
        let _arr = [];
        for (let j in _channelData) {
          if (_channelData[j].deviceSerial == this.editObj[i].deviceSerial) {
            delete _channelData[j].quality;
            delete _channelData[j].selected;
            delete _channelData[j].showSet;
            delete _channelData[j].speed;
            delete _channelData[j].deviceSerial;
            delete _channelData[j].is_upload;
            _arr.push(_channelData[j]);
          }
        }
        this.editObj[i].channel = _arr;
      }
      for (let i in this.editObj) {
        request({
          url: 'zgj-monitor/edit_ysy',
          method: 'POST',
          data: {
            id: this.editObj[i].id,
            channel: JSON.stringify(this.editObj[i].channel)
          }
        })
          .then(res => {
            this.editMonitorIsShow = false;
            this.$message.success(res.data);
            location.reload();
          })
          .catch(err => {
            this.$message.error(err.data);
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@/styles/mixin.scss';

.wrap {
  width: 1920px;
  min-height: 830px;
  margin: 10px 0;
  @include flex-box(center, center, column);
  .title {
    width: 1920px;
    height: 60px;
    line-height: 60px;
    font-size: 28px;
    text-align: center;
    position: relative;
    .btn {
      position: absolute;
      left: 30px;
      top: 10px;
      width: 106px;
      height: 32px;
      background: url(../../../assets/img/btn_bg_bsm.png) no-repeat;
      background-size: 100% 100%;
      color: #ffffff;
      font-size: 14px;
      cursor: pointer;
      @include flex-box(center, center);
      span {
        margin-top: -5px;
      }
    }
  }
  .cont_box {
    width: 1920px;
    height: 770px;
    position: relative;
    @include flex-box();
    .box_left {
      width: 280px;
      height: 770px;
      border: 1px solid #1d4495;
      border-left: none;
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
      background-color: rgba(29, 68, 149, 0.1);
      left: 0;
      top: 0;
      position: absolute;
      z-index: 10;
      &.close {
        left: -280px;
        transition: left 0.5s;
      }
      &.open {
        left: 0;
        transition: left 0.5s;
      }
      .open_btn,
      .close_btn {
        width: 50px;
        height: 60px;
        position: absolute;
        z-index: 10;
        font-weight: bold;
        top: 355px;
        right: -50px;
        cursor: pointer;
        background-color: rgba(255, 255, 255, 0.3);
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
        @include flex-box(center, center);
        img {
          width: 40px;
        }
      }
      .left_top {
        width: 280px;
        height: 120px;
        @include flex-box(flex-start, flex-start, cloumn, wrap);
        .list_title {
          width: 280px;
          height: 40px;
          line-height: 40px;
          font-size: 18px;
          color: #ffffff;
          border-top-right-radius: 10px;
          background-color: rgba(29, 68, 149, 0.3);
          box-shadow: 0 0 12px rgba(0, 0, 0, 0.16);
          padding-left: 20px;
        }
        .list_item {
          width: 280px;
          height: 80px;
          @include flex-box(space-around, center);
          .list_check {
            width: 60px;
            height: 70px;
            margin-top: 10px;
            @include flex-box(center, center, cloumn, wrap);
            .one {
              width: 40px;
              height: 40px;
              background: url(../../../assets/img/one.png) no-repeat;
              background-size: 100% 100%;
              &.active {
                background: url(../../../assets/img/one_select.png) no-repeat;
                background-size: 100% 100%;
              }
            }
            .four {
              width: 40px;
              height: 40px;
              background: url(../../../assets/img/four.png) no-repeat;
              background-size: 100% 100%;
              &.active {
                background: url(../../../assets/img/four_select.png) no-repeat;
                background-size: 100% 100%;
              }
            }
            .nine {
              width: 40px;
              height: 40px;
              background: url(../../../assets/img/nine.png) no-repeat;
              background-size: 100% 100%;
              &.active {
                background: url(../../../assets/img/nine_select.png) no-repeat;
                background-size: 100% 100%;
              }
            }
            .title {
              width: 60px;
              height: 30px;
              line-height: 30px;
              text-align: center;
              font-size: 12px;
              color: #ffffff;
            }
          }
        }
      }
      .left_bottom {
        width: 280px;
        height: 648px;
        position: relative;
        overflow: hidden;
        .left_title {
          width: 280px;
          height: 40px;
          line-height: 40px;
          padding-left: 20px;
          color: #ffffff;
          font-size: 18px;
          background-color: rgba(29, 68, 149, 0.3);
        }
        .list_box {
          width: 280px;
          height: 608px;
          position: relative;
          overflow: hidden;
          .list_all {
            position: absolute;
            left: 0;
            right: -20px;
            top: 0;
            bottom: 0;
            overflow-x: hidden;
            overflow-y: auto;
            @include flex-box(flex-start, flex-start, column);
            &.center {
              @include flex-box(center, center);
            }
            .list_item {
              margin: 20px 20px 0;
              width: 240px;
              height: 160px;
              border: 2px solid #1d4495;
              position: relative;
              &.active {
                border: 2px solid #ffa500;
              }
              &:last-child {
                margin-bottom: 20px;
              }
              .yes {
                position: absolute;
                bottom: 0;
                right: 0;
                width: 30px;
                height: 30px;
                font-size: 26px;
                font-weight: bold;
                color: #ffa500;
              }
              .item_title {
                width: 236px;
                padding-left: 10px;
                height: 30px;
                line-height: 30px;
                position: absolute;
                top: 0;
                left: 0;
                color: #ffffff;
                font-size: 16px;
                font-family: '宋体';
                background-color: rgba(0, 0, 0, 0.3);
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .item_img {
                width: 236px;
                height: 156px;
                img {
                  width: 100%;
                  height: 100%;
                }
              }
            }
          }
        }
      }
    }
    .monitor_live {
      width: 1320px;
      height: 770px;
      margin: 0 auto;
      position: relative;
      overflow: hidden;
      .control {
        position: absolute;
        top: 0;
        right: 0;
        cursor: pointer;
        width: 100px;
        height: 35px;
        z-index: 10;
        font-size: 16px;
        font-family: '宋体';
        background-color: rgba(0, 0, 0, 0.2);
        @include flex-box(space-between, flex-start);
        .btn {
          width: 50px;
          height: 35px;
          cursor: pointer;
          @include flex-box(center, center);
          &.active {
            color: #ffa500;
            font-size: 18px;
          }
        }
      }
      .control_set {
        width: 50px;
        border-bottom-left-radius: 4px;
        border-top-left-radius: 4px;
        font-size: 30px;
        color: #ffffff;
        padding: 2px 10px;
        opacity: 0;
        position: absolute;
        z-index: 3;
        cursor: pointer;
        top: 0;
        left: 0;
        @include prefixCss3(transition, opacity 0.5s);
      }
      .control_list {
        width: 270px;
        height: 115px;
        padding: 5px;
        position: absolute;
        z-index: 3;
        top: 10px;
        left: 50px;
        border-radius: 5px;
        background-color: #091120;
        @include flex-box(flex-start);
        .list_left {
          width: 40px;
          height: 105px;
          @include flex-box(flex-start, center, column, wrap);
          .left_top,
          .left_center,
          .left_bottom {
            width: 40px;
            height: 35px;
            @include flex-box(center, center);
          }
        }
        .list_center {
          width: 90px;
          height: 105px;
          @include flex-box(flex-start, center, column, wrap);
          .center_top,
          .center_center,
          .center_bottom {
            width: 90px;
            height: 35px;
            @include flex-box(space-around, center);
          }
        }
        .list_right {
          width: 130px;
          height: 105px;
          @include flex-box(flex-start, center, column, wrap);
          .right_top,
          .right_center,
          .right_bottom {
            width: 130px;
            height: 35px;
            @include flex-box(space-between, center);
          }
        }
      }
      &.one {
        border: 1px solid #1d4495;
        border-radius: 10px;
        height: 770px;
        &:hover {
          .control_set {
            opacity: 1;
          }
        }
        .video {
          width: 1316px;
          height: 766px;
        }
        .img {
          width: 1316px;
          height: 766px;
        }
      }
      &.four {
        height: 770px;
        @include flex-box(space-between, flex-start, row, wrap);
        .list_one {
          width: 650px;
          height: 375px;
          border: 2px solid #1d4495;
          position: relative;
          &:nth-child(1),
          &:nth-child(2) {
            margin-bottom: 19px;
          }
          &:hover {
            .control_set {
              opacity: 1;
            }
          }
          .video {
            width: 645px;
            height: 370px;
          }
          .img {
            width: 645px;
            height: 370px;
          }
        }
      }
      &.nine {
        height: 770px;
        @include flex-box(space-between, flex-start, row, wrap);
        .list_box {
          width: 425px;
          height: 245px;
          border: 2px solid #1d4495;
          position: relative;
          &:nth-child(1),
          &:nth-child(2),
          &:nth-child(3),
          &:nth-child(4),
          &:nth-child(5),
          &:nth-child(6) {
            margin-bottom: 15px;
          }
          &:hover {
            .control_set {
              opacity: 1;
            }
          }
          .video {
            width: 420px;
            height: 240px;
          }
          .img {
            width: 420px;
            height: 240px;
          }
        }
      }
    }
  }
}
.dialog_device,
.dialog_pic {
  .btn_line {
    @include flex-box(center, center);
  }
  >>> .el-dialog {
    width: 760px;
    height: 530px;
    margin-top: 20vh !important;
    background-color: rgba(9, 17, 32, 1);
    border: 1px solid rgba(58, 116, 221, 1);
  }
  >>> .el-dialog__body {
    padding: 10px;
  }
  >>> .el-form-item__label {
    color: #4db4f4;
  }
  >>> .el-dialog__title {
    color: #4db4f4;
  }
  >>> .el-dialog__close {
    color: #4db4f4;
  }
}
.cont_list {
  width: 740px;
  height: 390px;
  border-radius: 10px;
  background-color: rgba(29, 68, 149, 0.1);
  .list_title {
    width: 740px;
    height: 48px;
    color: #ffffff;
    background: url(../../../assets/img/per_list_bg.png) no-repeat;
    background-size: 100% 100%;
    @include flex-box(flex-start, center);
    .title_item {
      height: 48px;
      @include flex-box(center, center);
      &:nth-child(1) {
        width: 208px;
        margin-right: 2px;
        margin-left: 30px;
      }
      &:nth-child(2) {
        width: 136px;
        margin: 0 2px;
      }
      &:nth-child(3) {
        width: 176px;
        margin: 0 2px;
      }
      &:nth-child(4) {
        width: 148px;
        margin: 0 30px 0 2px;
      }
    }
  }
  .list_boxes {
    width: 740px;
    height: 340px;
    position: relative;
    overflow: hidden;
    .list_box {
      position: absolute;
      left: 0;
      right: -25px;
      top: 0;
      bottom: 0;
      overflow-x: hidden;
      overflow-y: auto;
      .box_line {
        width: 680px;
        height: 110px;
        margin: 7px 0 0 30px;
        font-size: 16px;
        color: #ffffff;
        border-bottom: 1px dashed #1d4495;
        @include flex-box(flex-start, center);
        &:hover {
          background-color: rgba(49, 88, 128, 0.4);
        }
        .list_item {
          height: 110px;
          text-align: center;
          @include flex-box(center, center);
          &:nth-child(1) {
            width: 208px;
            margin-right: 2px;
          }
          &:nth-child(2) {
            width: 136px;
            margin: 0 2px;
          }
          &:nth-child(3) {
            width: 176px;
            margin: 0 2px;
          }
          &:nth-child(4) {
            width: 148px;
            margin-left: 2px;
          }
          img {
            width: 40px;
            height: 40px;
            border-radius: 50%;
          }
          div {
            @include flex-box(center, center);
            .item_btn {
              width: 80px;
              height: 32px;
              line-height: 32px;
              margin: 0 2px;
              font-size: 14px;
              color: #ffffff;
              border: none;
              cursor: pointer;
              @include flex-box(center, center);
              &.blue {
                background: url(../../../assets/img/btn_bg_bsm.png) no-repeat;
                background-size: 100% 100%;
              }
              &.yellow {
                background: url(../../../assets/img/btn_bg_osm.png) no-repeat;
                background-size: 100% 100%;
              }
              span {
                margin-top: -2px;
              }
            }
            .cover_img /deep/ {
              display: inline-block;
              .avatar-uploader {
                display: inline-block;
                line-height: 100px;
                width: 100px;
                height: 100px;
              }

              .avatar-uploader .el-upload {
                width: 100px;
                height: 100px;
                line-height: 100px;
                border-radius: 5px;
                border: 1px dashed #1d4495;
              }

              .avatar-uploader .el-upload .avatar-uploader-icon {
                line-height: inherit;
              }

              .avatar-uploader img {
                width: 100px;
                height: 100px;
                border-radius: 5px;
              }
            }
            .cover_btn {
              width: 110px;
              display: inline-block;
              vertical-align: middle;
            }
          }
        }
      }
    }
  }
}
.add_btn {
  float: right;
  width: 110px;
  height: 28px;
  line-height: 28px;
  font-size: 14px;
  color: #ffffff;
  border: none;
  cursor: pointer;
  @include flex-box(center, center);
  &.blue {
    background: url(../../../assets/img/btn_bg_bsm.png) no-repeat;
    background-size: 100% 100%;
  }
  &.yellow {
    background: url(../../../assets/img/btn_bg_osm.png) no-repeat;
    background-size: 100% 100%;
  }
  span {
    margin-top: -2px;
  }
}
.control_btn {
  width: 40px;
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  color: #ffffff;
  border: none;
  cursor: pointer;
  @include flex-box(center, center);
  &.blue {
    background: url(../../../assets/img/btn_bg_bsm.png) no-repeat;
    background-size: 100% 100%;
  }
  &.yellow {
    background: url(../../../assets/img/btn_bg_osm.png) no-repeat;
    background-size: 100% 100%;
  }
  &.big {
    width: 90px;
  }
  &.f-20 {
    font-size: 20px;
  }
  span {
    margin-top: -2px;
  }
}
.line_input2 {
  min-width: 150px;
  height: 30px;
  border-top-right-radius: 1px;
  border-bottom-right-radius: 1px;
  background-color: rgba(49, 88, 128, 0.4);
  @include flex-box(flex-start, center);
  .input_title {
    width: 69px;
    height: 30px;
    font-size: 14px;
    color: #9bf9fc;
    border-radius: 2px;
    background-color: rgba(155, 249, 252, 0.1);
    @include flex-box(center, center);
  }
  .input_box {
    width: 150px;
    height: 30px;
    line-height: 30px;
    color: rgba(77, 180, 244, 0.7);
    font-size: 12px;
    border-radius: 2px;
    outline: none;
    background: transparent;
    border: none;
    &::-webkit-input-placeholder {
      color: rgba(77, 180, 244, 0.7);
    }
    &::-moz-placeholder {
      /* Mozilla Firefox 19+ */
      color: rgba(77, 180, 244, 0.7);
    }
    &:-moz-placeholder {
      /* Mozilla Firefox 4 to 18 */
      color: rgba(77, 180, 244, 0.7);
    }
    &:-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: rgba(77, 180, 244, 0.7);
    }
  }
  .select_box {
    width: 211px;
    height: 30px;
    border-radius: 2px;
  }
}
.dialog_pic {
  >>> .el-dialog {
    width: 1000px;
    height: 800px;
    margin-top: 20vh !important;
    background-color: rgba(9, 17, 32, 1);
    border: 1px solid rgba(58, 116, 221, 1);
  }
  >>> .el-dialog__body {
    padding: 20px;
  }
  .cover_pic {
    width: 960px;
    height: 650px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/MonitorLive/MonitorLiveDefault/index.vue